(() => {
  if (location.hostname === '127.0.0.1') {
    location.replace(location.href.replace('127.0.0.1', 'localhost'));
    return;
  }

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  qsa('.shopify-policy__body .rte > p').forEach((p) => {
    if (/^last updated/i.test(p.textContent.trim())) {
      p.classList.add('shopify-policy__updated');
    }
  });

  const header = qs('[data-header]');
  const exploreBtn = qs('[data-explore-toggle]');
  const exploreMenu = qs('[data-explore-menu]');
  const navToggle = qs('[data-nav-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  const navScrim = qs('[data-nav-scrim]');

  const setMobileNav = (open) => {
    if (!mobileNav || !navToggle) return;
    mobileNav.setAttribute('data-open', String(open));
    navToggle.setAttribute('aria-expanded', String(open));
    if (navScrim) navScrim.setAttribute('data-open', String(open));
    document.documentElement.classList.toggle('vk-nav-open', open);
  };

  if (exploreBtn && exploreMenu) {
    const exploreWrap = exploreBtn.closest('.vk-header__explore-wrap');
    let hoverTimer;
    const setExplore = (open) => {
      exploreMenu.setAttribute('data-open', String(open));
      exploreBtn.setAttribute('aria-expanded', String(open));
    };
    exploreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isTouch = window.matchMedia('(hover: none)').matches;
      if (isTouch) {
        setExplore(exploreMenu.getAttribute('data-open') !== 'true');
      } else {
        setExplore(true);
      }
    });
    if (exploreWrap) {
      exploreWrap.addEventListener('mouseenter', () => {
        window.clearTimeout(hoverTimer);
        setExplore(true);
      });
      exploreWrap.addEventListener('mouseleave', () => {
        hoverTimer = window.setTimeout(() => setExplore(false), 160);
      });
    }
    document.addEventListener('click', (e) => {
      if (!exploreMenu.contains(e.target) && !exploreBtn.contains(e.target)) {
        setExplore(false);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setExplore(false);
    });
  }

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = mobileNav.getAttribute('data-open') !== 'true';
      setMobileNav(open);
    });

    mobileNav.addEventListener('click', (e) => {
      if (e.target.closest('a')) setMobileNav(false);
    });

    if (navScrim) {
      navScrim.addEventListener('click', () => setMobileNav(false));
    }

    document.addEventListener('click', (e) => {
      if (mobileNav.getAttribute('data-open') !== 'true') return;
      if (mobileNav.contains(e.target) || navToggle.contains(e.target)) return;
      setMobileNav(false);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    setMobileNav(false);
  });

  if (header) {
    let lastY = window.scrollY;
    let ticking = false;
    const updateHeader = () => {
      ticking = false;
      const y = window.scrollY;
      const atTop = y <= 8;
      const navOpen = document.documentElement.classList.contains('vk-nav-open');
      header.setAttribute('data-scrolled', atTop ? 'false' : 'true');
      if (atTop || navOpen) {
        header.setAttribute('data-hidden', 'false');
      } else if (y > lastY + 4) {
        header.setAttribute('data-hidden', 'true');
      } else if (y < lastY - 1) {
        header.setAttribute('data-hidden', 'false');
      }
      lastY = y;
    };
    updateHeader();
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateHeader);
        }
      },
      { passive: true }
    );
  }

  qsa('[data-tabs]').forEach((tabs) => {
    const buttons = qsa('[data-tab]', tabs);
    const panels = qsa('[data-tab-panel]', tabs);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-tab');
        buttons.forEach((b) => b.setAttribute('data-active', b === btn ? 'true' : 'false'));
        panels.forEach((p) => p.setAttribute('data-active', p.getAttribute('data-tab-panel') === id ? 'true' : 'false'));
      });
    });
  });

  const absUrl = (src) => {
    try {
      return new URL(src, document.baseURI).href;
    } catch {
      return src || '';
    }
  };

  const flavorGallery = (pdp, flavorName) => {
    if (!pdp || !flavorName) return [];
    try {
      const gallery = JSON.parse(pdp.getAttribute('data-flavor-gallery') || '{}');
      return gallery[flavorName] || [];
    } catch (err) {
      return [];
    }
  };

  const setPdpFlavor = (flavorName, imageSrc) => {
    const pdp = qs('.pdp');
    const wrap = qs('.pdp__hero-wrap', pdp || document);
    const layers = wrap ? qsa('.pdp__hero', wrap) : [];
    const front = layers.find((img) => img.classList.contains('is-front')) || layers[0];
    const back = layers.find((img) => img !== front);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = imageSrc ? absUrl(imageSrc) : '';

    if (front && target && absUrl(front.currentSrc || front.src) !== target) {
      if (reduce || !back) {
        front.src = imageSrc;
        if (flavorName) front.alt = flavorName;
      } else {
        const gen = (wrap._pdpGen = (wrap._pdpGen || 0) + 1);
        let settled = false;
        const reveal = () => {
          if (settled || wrap._pdpGen !== gen) return;
          settled = true;
          back.classList.add('is-front');
          front.classList.remove('is-front');
          if (flavorName) back.alt = flavorName;
          back.removeAttribute('aria-hidden');
          front.setAttribute('aria-hidden', 'true');
        };
        const onReady = () => {
          back.removeEventListener('load', onReady);
          window.requestAnimationFrame(reveal);
        };
        back.addEventListener('load', onReady);
        if (flavorName) back.alt = flavorName;
        back.src = imageSrc;
        if (back.complete && absUrl(back.currentSrc || back.src) === target && back.naturalWidth) {
          onReady();
        }
      }
    }

    const flavorThumb = qs('[data-pdp-thumb="flavor"]', pdp || document);
    const skipThumb = qs('[data-pdp-thumb="skip"]', pdp || document);
    if (flavorName) {
      const shots = flavorGallery(pdp, flavorName);
      if (shots[0] && flavorThumb) {
        flavorThumb.setAttribute('data-pdp-image', shots[0]);
        const thumbImg = qs('img', flavorThumb);
        if (thumbImg && absUrl(thumbImg.getAttribute('src')) !== absUrl(shots[0])) {
          thumbImg.src = shots[0];
          thumbImg.alt = flavorName;
        }
      }
      if (shots[2] && skipThumb) {
        skipThumb.setAttribute('data-pdp-image', shots[2]);
        const skipImg = qs('img', skipThumb);
        if (skipImg && absUrl(skipImg.getAttribute('src')) !== absUrl(shots[2])) {
          skipImg.src = shots[2];
        }
      }
    }

    qsa('[data-pdp-thumb]', pdp || document).forEach((thumb) => {
      const shot = absUrl(thumb.getAttribute('data-pdp-image'));
      const match = Boolean(target && shot === target);
      thumb.classList.toggle('is-active', match);
      if (match) {
        thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
    });
    if (flavorName) {
      if (pdp) pdp.setAttribute('data-selected-flavor', flavorName);
      qsa('[data-flavor][data-flavor-name]').forEach((btn) => {
        const on = btn.getAttribute('data-flavor-name') === flavorName;
        btn.setAttribute('data-active', on ? 'true' : 'false');
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const label = qs('[data-flavor-label]');
      if (label) label.textContent = 'Flavor: ' + flavorName;
      const titleFlavor = qs('[data-pdp-title-flavor]');
      if (titleFlavor) titleFlavor.textContent = flavorName;
      const variantId = qsa('[data-flavor][data-flavor-name]').find((n) => n.getAttribute('data-flavor-name') === flavorName)?.getAttribute('data-variant-id');
      const variantInput = qs('[data-pdp-variant], .pdp__form input[name="id"]');
      if (variantInput && variantId) variantInput.value = variantId;
      syncPdpBuyCta(flavorName);
    }
  };

  const syncPdpBuyCta = (flavorName) => {
    const name = flavorName || qs('.pdp')?.getAttribute('data-selected-flavor') || '';
    const flavorBtn = qsa('[data-flavor][data-flavor-name]').find((n) => n.getAttribute('data-flavor-name') === name);
    const submit = qs('[data-pdp-submit], .pdp__submit');
    if (!submit) return;
    const available = !flavorBtn || flavorBtn.getAttribute('data-available') !== 'false';
    const buy = submit.getAttribute('data-label-buy') || 'Buy now';
    const sold = submit.getAttribute('data-label-sold') || 'Out of stock';
    submit.disabled = !available;
    if (available) submit.removeAttribute('aria-disabled');
    else submit.setAttribute('aria-disabled', 'true');
    if (submit.getAttribute('aria-busy') !== 'true') {
      submit.textContent = available ? buy : sold;
    }
  };

  const applyFlavorFromControl = (btn, { updateHistory = true } = {}) => {
    const flavorName = btn.getAttribute('data-flavor-name');
    setPdpFlavor(flavorName, btn.getAttribute('data-pdp-image'));
    if (!updateHistory) return;
    const url = btn.getAttribute('data-flavor-url');
    if (!url) return;
    const next = new URL(url, window.location.origin);
    if (next.pathname === window.location.pathname && next.search === window.location.search) return;
    window.history.pushState({ flavor: flavorName }, '', next.pathname + next.search);
  };

  qsa('[data-flavor][data-flavor-name]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      applyFlavorFromControl(btn);
    });
  });

  window.addEventListener('popstate', () => {
    const path = window.location.pathname;
    const match = qsa('[data-flavor][data-flavor-name]').find((btn) => {
      const url = btn.getAttribute('data-flavor-url');
      if (!url) return false;
      return new URL(url, window.location.origin).pathname === path;
    });
    if (match) applyFlavorFromControl(match, { updateHistory: false });
  });

  const pdpRoot = qs('.pdp');
  if (pdpRoot) {
    const queryFlavor = new URLSearchParams(window.location.search).get('flavor');
    const pageFlavor = queryFlavor || pdpRoot.getAttribute('data-selected-flavor');
    if (pageFlavor) {
      const match = qsa('[data-flavor]', pdpRoot).find((btn) => btn.getAttribute('data-flavor-name') === pageFlavor);
      if (match) setPdpFlavor(pageFlavor, match.getAttribute('data-pdp-image'));
    }
  }

  qsa('[data-pdp-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const pdp = qs('.pdp');
      const flavor = pdp?.getAttribute('data-selected-flavor') || '';
      setPdpFlavor(flavor, thumb.getAttribute('data-pdp-image'));
    });
  });

  const stepPdpThumb = (dir) => {
    const pdp = qs('.pdp');
    const front = qs('.pdp__hero.is-front', pdp || document);
    const currentSrc = absUrl(front?.currentSrc || front?.src || '');
    const flavor = pdp?.getAttribute('data-selected-flavor') || '';
    const shots = flavorGallery(pdp, flavor);
    if (!shots.length) return;
    let shotIdx = shots.findIndex((src) => absUrl(src) === currentSrc);
    if (shotIdx < 0) shotIdx = 0;
    const next = shots[(shotIdx + dir + shots.length) % shots.length];
    setPdpFlavor(flavor, next);
  };
  qs('[data-pdp-prev]')?.addEventListener('click', () => stepPdpThumb(-1));
  qs('[data-pdp-next]')?.addEventListener('click', () => stepPdpThumb(1));

  const bindPdpSwipe = (el) => {
    if (!el) return;
    let startX = 0;
    let startY = 0;
    let tracking = false;
    el.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
    });
    el.addEventListener('pointerup', (event) => {
      if (!tracking) return;
      tracking = false;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      stepPdpThumb(dx < 0 ? 1 : -1);
    });
    el.addEventListener('pointercancel', () => {
      tracking = false;
    });
  };
  bindPdpSwipe(qs('.pdp__hero-wrap'));
  bindPdpSwipe(qs('[data-pdp-thumbs]'));

  const qtyInput = qs('[data-pdp-quantity]');
  const qtyMinus = qs('[data-pdp-qty-minus]');
  const qtyPlus = qs('[data-pdp-qty-plus]');
  const qtyLabel = qs('[data-qty-label]');
  const sellingInput = qs('[data-pdp-selling-plan]');
  const packRow = qs('.pdp__pack-price');
  const packLabel = qs('[data-pdp-pack]');
  const pdpVolumeRate = (qty) => (qty >= 5 ? 0.85 : qty >= 3 ? 0.9 : qty >= 2 ? 0.95 : 1);
  const readPdpPackSize = () => {
    const next = Number(packRow && packRow.getAttribute('data-pdp-pack-size'));
    return next > 0 ? next : 6;
  };
  const readPdpIsPack = () => (packRow && packRow.getAttribute('data-pdp-is-pack')) === 'true';
  const readPdpQty = () => {
    const next = Math.max(1, Math.min(20, Math.round(Number(qtyInput && qtyInput.value) || 1)));
    if (qtyInput && String(next) !== qtyInput.value) qtyInput.value = String(next);
    return next;
  };
  const hidePdpVariantDropdowns = () => {
    qsa('.pdp select, .pdp [class*="appstle"] select, .pdp [id*="Appstle"] select').forEach((sel) => {
      if (sel.hasAttribute('data-pdp-plan-select')) return;
      sel.classList.add('visually-hidden');
      sel.setAttribute('aria-hidden', 'true');
      sel.tabIndex = -1;
    });
  };
  const syncPdpPurchase = () => {
    const qty = readPdpQty();
    const packSize = readPdpPackSize();
    const isPack = readPdpIsPack();
    if (qtyMinus) qtyMinus.disabled = qty <= 1;
    if (qtyPlus) qtyPlus.disabled = qty >= 20;
    if (packLabel) {
      packLabel.textContent = isPack ? (qty + ' × ' + packSize + '-pack') : (qty === 1 ? '1 item' : qty + ' items');
    }
    if (qtyLabel) {
      qtyLabel.textContent = isPack
        ? (qty === 1 ? '1 box' : qty + ' boxes')
        : (qty === 1 ? '1 item' : qty + ' items');
    }
    const freq = qs('[data-pdp-freq] input:checked');
    const planSelect = qs('[data-pdp-plan-select]');
    const planField = qs('[data-pdp-plan-field]');
    const subscribed = Boolean(freq && freq.value === 'subscribe');
    if (planField) planField.hidden = !subscribed;
    if (planSelect) planSelect.disabled = !subscribed;
    if (subscribed && freq && planSelect && planSelect.value) {
      freq.setAttribute('data-selling-plan-id', planSelect.value);
    }
    const planId = subscribed
      ? ((planSelect && planSelect.value) || (freq && freq.getAttribute('data-selling-plan-id')) || '')
      : '';
    if (sellingInput) {
      if (planId) {
        sellingInput.name = 'selling_plan';
        sellingInput.value = planId;
        sellingInput.disabled = false;
      } else {
        sellingInput.removeAttribute('name');
        sellingInput.value = '';
        sellingInput.disabled = true;
      }
    }
    const tracker = qs('[data-discount-tracker]');
    const unit = Number((tracker && tracker.getAttribute('data-unit-cents')) || 2699);
    const total = Math.round(unit * qty * pdpVolumeRate(qty) * (subscribed ? 0.85 : 1));
    const bottles = Math.max(qty * (isPack ? packSize : 1), 1);
    const each = Math.round(total / bottles);
    const totalEl = qs('[data-pdp-total]');
    const eachWrap = qs('[data-pdp-each]');
    const eachEl = (eachWrap && eachWrap.querySelector('[data-money]')) || eachWrap;
    if (totalEl) totalEl.setAttribute('data-cents', String(total));
    if (eachEl && isPack) eachEl.setAttribute('data-cents', String(each));
    if (eachWrap) eachWrap.hidden = !isPack;
    hidePdpVariantDropdowns();
    if (afterPdpSync) afterPdpSync();
  };
  let afterPdpSync = null;
  qs('[data-pdp-qty-minus]')?.addEventListener('click', () => {
    if (!qtyInput || qtyMinus && qtyMinus.disabled) return;
    qtyInput.value = String(Math.max(1, readPdpQty() - 1));
    syncPdpPurchase();
    if (typeof updateTracker === 'function') updateTracker();
  });
  qs('[data-pdp-qty-plus]')?.addEventListener('click', () => {
    if (!qtyInput || qtyPlus && qtyPlus.disabled) return;
    qtyInput.value = String(Math.min(20, readPdpQty() + 1));
    syncPdpPurchase();
    if (typeof updateTracker === 'function') updateTracker();
  });
  if (qtyInput) {
    const onQtyEdit = () => {
      syncPdpPurchase();
      if (typeof updateTracker === 'function') updateTracker();
    };
    qtyInput.addEventListener('input', onQtyEdit);
    qtyInput.addEventListener('change', onQtyEdit);
  }
  qsa('[data-pdp-freq] input').forEach((input) => {
    input.addEventListener('change', () => {
      syncPdpPurchase();
      if (typeof updateTracker === 'function') updateTracker();
    });
  });
  qsa('[data-pdp-plan-select] option').forEach((opt) => {
    const match = String(opt.textContent || '').match(/Every\s+\d+\s+(?:Day|Week|Month)s?/i);
    if (match) opt.textContent = match[0];
  });
  qs('[data-pdp-plan-select]')?.addEventListener('change', () => {
    const sub = qs('[data-pdp-freq] input[value="subscribe"]');
    if (sub) sub.checked = true;
    syncPdpPurchase();
    if (typeof updateTracker === 'function') updateTracker();
  });
  syncPdpPurchase();
  window.setTimeout(hidePdpVariantDropdowns, 600);
  window.setTimeout(hidePdpVariantDropdowns, 2000);

  const klaviyoCompany = document.body.getAttribute('data-klaviyo-company') || 'VMER7L';
  const klaviyoFormId = (document.body.getAttribute('data-klaviyo-form') || 'RFhUg3').trim();
  const klaviyoList = (document.body.getAttribute('data-klaviyo-list') || '').trim();

  const postKlaviyo = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15',
      },
      body: JSON.stringify(body),
    });
    if (!res.ok && res.status !== 202 && res.status !== 201) {
      throw new Error(String(res.status));
    }
  };

  const pierceQuery = (root, selector) => {
    if (!root) return null;
    if (root.querySelector) {
      const hit = root.querySelector(selector);
      if (hit) return hit;
    }
    const nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (const node of nodes) {
      if (node.shadowRoot) {
        const nested = pierceQuery(node.shadowRoot, selector);
        if (nested) return nested;
      }
    }
    return null;
  };

  const waitForKlaviyoEmbed = (timeout = 8000) =>
    new Promise((resolve, reject) => {
      const root = document.querySelector('.klaviyo-form-' + klaviyoFormId);
      if (!root) {
        reject(new Error('embed missing'));
        return;
      }
      const grab = () => {
        const emailInput = pierceQuery(root, 'input[type="email"], input[name="email"]');
        const phoneInput = pierceQuery(root, 'input[type="tel"], input[name="phone"], input[name="phone_number"]');
        const button = pierceQuery(root, 'button[type="submit"], button');
        return emailInput && button ? { emailInput, phoneInput, button } : null;
      };
      const ready = grab();
      if (ready) {
        resolve(ready);
        return;
      }
      const obs = new MutationObserver(() => {
        const found = grab();
        if (found) {
          obs.disconnect();
          resolve(found);
        }
      });
      obs.observe(root, { childList: true, subtree: true });
      window.setTimeout(() => {
        obs.disconnect();
        reject(new Error('embed timeout'));
      }, timeout);
    });

  const toE164 = (raw) => {
    const value = String(raw || '').trim();
    if (!value) return '';
    if (value.startsWith('+')) {
      const digits = value.slice(1).replace(/\D/g, '');
      return digits.length >= 10 && digits.length <= 15 ? '+' + digits : '';
    }
    const digits = value.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (digits.length >= 10 && digits.length <= 15) return '+' + digits;
    return '';
  };

  const fillNativeInput = (input, value) => {
    if (!input) return;
    const descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (descriptor && descriptor.set) descriptor.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const submitKlaviyoEmbed = async (email, phone) => {
    const { emailInput, phoneInput, button } = await waitForKlaviyoEmbed();
    fillNativeInput(emailInput, email);
    if (phone) fillNativeInput(phoneInput, phone);
    const submitted = new Promise((resolve, reject) => {
      const timer = window.setTimeout(() => reject(new Error('submit timeout')), 10000);
      const onForms = (event) => {
        const type = event.detail && event.detail.type;
        if (type === 'submit' || type === 'stepSubmit' || type === 'redirectedToUrl') {
          window.clearTimeout(timer);
          window.removeEventListener('klaviyoForms', onForms);
          resolve();
        }
      };
      window.addEventListener('klaviyoForms', onForms);
    });
    button.click();
    await submitted;
  };

  const subscribeShopify = async (form) => {
    const action = form.getAttribute('action') || '/contact';
    const body = new FormData(form);
    const res = await fetch(action, {
      method: 'POST',
      body,
      headers: { Accept: 'application/javascript' },
    });
    if (!res.ok && res.status >= 400) throw new Error(String(res.status));
  };

  const subscribeKlaviyo = async (email, source, phone) => {
    const identity = { email, source, $source: source, $consent: phone ? ['email', 'sms'] : ['email'] };
    if (phone) identity.phone_number = phone;
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      window.klaviyo.identify(identity);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['identify', identity]);
    }

    const profileAttributes = {
      email,
      subscriptions: {
        email: { marketing: { consent: 'SUBSCRIBED' } },
      },
    };
    if (phone) {
      profileAttributes.phone_number = phone;
      profileAttributes.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }

    const subscription = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes,
            },
          },
        },
      },
    };
    if (klaviyoList) {
      subscription.data.relationships = {
        list: { data: { type: 'list', id: klaviyoList } },
      };
    }

    if (klaviyoFormId) {
      try {
        await submitKlaviyoEmbed(email, phone);
      } catch (err) {
        /* still subscribe via API */
      }
    }

    try {
      await postKlaviyo(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(klaviyoCompany)}`,
        subscription
      );
    } catch (err) {
      const profile = { email, properties: { source, form_id: klaviyoFormId } };
      if (phone) profile.phone_number = phone;
      await postKlaviyo(`https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(klaviyoCompany)}`, {
        data: {
          type: 'profile',
          attributes: profile,
        },
      });
    }
  };

  qsa('[data-klaviyo-source]').forEach((node) => {
    const form = node.closest('form') || (node.matches('form') ? node : null);
    if (!form || form.dataset.vkSubscribeBound === '1') return;
    if (!qs('input[type="email"]', form)) return;
    form.dataset.vkSubscribeBound = '1';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const emailInput = qs('input[type="email"]', form);
      const phoneInput = qs('[data-klaviyo-phone], input[type="tel"]', form);
      const status = qs('[data-klaviyo-status]', form);
      const button = qs('button[type="submit"]', form);
      const email = emailInput && emailInput.value.trim();
      const sourceNode = qs('[data-klaviyo-source]', form) || form;
      const source = sourceNode.getAttribute('data-klaviyo-source') || 'Footer';
      if (!email || !emailInput.checkValidity()) {
        if (emailInput) emailInput.reportValidity();
        return;
      }
      let phone = '';
      if (phoneInput && phoneInput.value.trim()) {
        phone = toE164(phoneInput.value);
        if (!phone) {
          phoneInput.setCustomValidity('Enter a valid phone number');
          phoneInput.reportValidity();
          phoneInput.setCustomValidity('');
          return;
        }
        phoneInput.value = phone;
      }
      if (button) button.disabled = true;
      try {
        const jobs = [subscribeKlaviyo(email, source, phone)];
        if ((form.getAttribute('action') || '').includes('/contact') || form.querySelector('[name="form_type"][value="customer"]')) {
          jobs.push(subscribeShopify(form));
        }
        const results = await Promise.allSettled(jobs);
        if (results.every((result) => result.status === 'rejected')) {
          throw results[0].reason || new Error('subscribe failed');
        }
        if (status) {
          status.hidden = false;
          status.dataset.state = 'ok';
          const ok = qs('[data-klaviyo-ok]', status);
          const err = qs('[data-klaviyo-err]', status);
          if (ok) ok.hidden = false;
          if (err) err.hidden = true;
        }
        form.reset();
        const popupParent = form.closest('[data-offer-popup]');
        if (popupParent) {
          window.setTimeout(() => {
            popupParent.setAttribute('data-open', 'false');
            sessionStorage.setItem('vktry-popup-dismissed', '1');
          }, 900);
        }
      } catch (err) {
        if (status) {
          status.hidden = false;
          status.dataset.state = 'err';
          const ok = qs('[data-klaviyo-ok]', status);
          const err = qs('[data-klaviyo-err]', status);
          if (ok) ok.hidden = true;
          if (err) err.hidden = false;
        }
      } finally {
        if (button) button.disabled = false;
      }
    });
  });

  const popup = qs('[data-offer-popup]');
  if (popup) {
    const dismissPopup = () => {
      popup.setAttribute('data-open', 'false');
      try {
        sessionStorage.setItem('vktry-popup-dismissed', '1');
      } catch (err) {
        /* private mode */
      }
    };
    qsa('[data-popup-close]', popup).forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        dismissPopup();
      });
    });
    popup.addEventListener('click', (event) => {
      if (event.target === popup) dismissPopup();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.getAttribute('data-open') === 'true') {
        dismissPopup();
      }
    });
    let dismissed = false;
    try {
      dismissed = Boolean(sessionStorage.getItem('vktry-popup-dismissed'));
    } catch (err) {
      dismissed = false;
    }
    if (!dismissed) {
      window.setTimeout(() => popup.setAttribute('data-open', 'true'), 30000);
    }
  }

  qsa('.vk-locator__embed').forEach((frame) => {
    const box = frame.closest('.vk-locator');
    if (!box) return;
    const fail = () => box.setAttribute('data-embed-failed', 'true');
    frame.addEventListener('error', fail);
    window.setTimeout(() => {
      try {
        if (!frame.contentWindow) fail();
      } catch (err) {
        /* cross-origin load still counts as success */
      }
    }, 8000);
  });

  const fillStatsMarquee = (section) => {
    const viewport = qs('.vk-stats__viewport', section);
    const track = qs('.vk-stats__track', section);
    const first = track && qs('.vk-stats__seq', track);
    if (!viewport || !track || !first) return;

    track.style.animation = 'none';
    qsa('[data-stats-clone]', track).forEach((node) => node.remove());

    const seqWidth = first.getBoundingClientRect().width;
    const viewWidth = viewport.getBoundingClientRect().width;
    if (seqWidth < 1) {
      track.style.animation = '';
      return;
    }

    const needed = Math.max(2, Math.ceil(viewWidth / seqWidth) + 1);
    let have = qsa('.vk-stats__seq', track).length;
    while (have < needed) {
      const clone = first.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-stats-clone', '');
      track.appendChild(clone);
      have += 1;
    }

    track.style.setProperty('--stats-cycle', `${Math.round(seqWidth * 100) / 100}px`);
    track.style.animation = '';
  };

  const initStatsMarquees = () => {
    const sections = qsa('[data-stats-marquee], .vk-stats');
    if (!sections.length) return;
    const run = () => sections.forEach(fillStatsMarquee);
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(run, 100);
    });
  };

  initStatsMarquees();

  qsa('[data-carousel]').forEach((carousel) => {
    const slides = qsa('[data-slide]', carousel);
    if (slides.length < 2) return;
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => s.setAttribute('data-active', idx === i ? 'true' : 'false'));
    };
    show(0);
    const prev = qs('[data-prev]', carousel);
    const next = qs('[data-next]', carousel);
    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));
  });

  const initBlendPie = () => {
    qsa('.vk-blend__row').forEach((row) => {
      const setPie = (side) => {
        if (side) row.setAttribute('data-pie', side);
        else row.removeAttribute('data-pie');
      };
      const sideFrom = (node) => {
        const hit = node && node.closest && node.closest('[data-blend-side]');
        return hit ? hit.getAttribute('data-blend-side') : null;
      };
      row.addEventListener('pointermove', (e) => setPie(sideFrom(e.target)));
      row.addEventListener('pointerover', (e) => setPie(sideFrom(e.target)));
      row.addEventListener('pointerout', (e) => {
        if (!row.contains(e.relatedTarget)) setPie(null);
      });
      row.addEventListener('focusin', (e) => setPie(sideFrom(e.target)));
      row.addEventListener('focusout', () => {
        if (!row.contains(document.activeElement)) setPie(null);
      });
      row.addEventListener('click', (e) => {
        if (!window.matchMedia('(hover: none)').matches) return;
        const next = sideFrom(e.target);
        setPie(row.getAttribute('data-pie') === next ? null : next);
      });
    });

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const setItemOpen = (item, open) => {
      const hit = qs('.vk-blend__hit', item);
      item.classList.toggle('is-open', open);
      if (hit) hit.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const openExclusive = (item) => {
      qsa('li', item.parentElement).forEach((other) => setItemOpen(other, other === item));
    };
    qsa('.vk-blend__col li').forEach((item) => {
      const hit = qs('.vk-blend__hit', item);
      if (!hit) return;
      item.addEventListener('mouseenter', () => {
        if (canHover.matches) openExclusive(item);
      });
      hit.addEventListener('click', (e) => {
        if (canHover.matches) return;
        e.preventDefault();
        const open = !item.classList.contains('is-open');
        qsa('li', item.parentElement).forEach((other) => {
          if (other !== item) setItemOpen(other, false);
        });
        setItemOpen(item, open);
      });
    });
  };

  const initBlendSpin = () => {
    const canvas = qs('[data-blend-bottle]');
    const section = canvas && canvas.closest('.vk-blend');
    if (!canvas || !section || canvas.tagName !== 'CANVAS') return;

    const frames = (canvas.getAttribute('data-blend-frames') || '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
    if (frames.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const frameW = Number(canvas.getAttribute('width')) || 360;
    const frameH = Number(canvas.getAttribute('height')) || 786;
    const n = frames.length;
    canvas.width = Math.round(frameW * dpr);
    canvas.height = Math.round(frameH * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.imageSmoothingEnabled = true;

    const images = frames.map((src) => {
      const im = new Image();
      im.decoding = 'async';
      im.src = src;
      return im;
    });

    let ready = false;
    let current = 0;
    let seeded = false;

    const paint = (index) => {
      const i0 = ((Math.round(index) % n) + n) % n;
      const frame = images[i0];
      if (!frame || !frame.complete || !frame.naturalWidth) return;
      ctx.clearRect(0, 0, frameW, frameH);
      ctx.globalAlpha = 1;
      ctx.drawImage(frame, 0, 0, frameW, frameH);
    };

    images[0].addEventListener('load', () => paint(0), { once: true });
    Promise.all(images.map((im) => im.decode().catch(() => {}))).then(() => {
      ready = true;
      paint(0);
    });

    if (reduce) return;

    const visual = qs('.vk-blend__visual', section) || canvas;

    const indexFromScroll = () => {
      const rect = visual.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const center = rect.top + rect.height * 0.5;
      let t = (vh * 0.5 - center) / Math.max(1, vh * 0.72);
      t = Math.max(-0.5, Math.min(0.5, t));
      return ((t * n) % n + n) % n;
    };

    const shortest = (from, to) => {
      let d = to - from;
      if (d > n * 0.5) d -= n;
      if (d < -n * 0.5) d += n;
      return d;
    };

    const loop = () => {
      if (ready) {
        const target = indexFromScroll();
        if (!seeded) {
          current = target;
          seeded = true;
        } else {
          current = (current + shortest(current, target) * 0.2 + n) % n;
        }
        paint(current);
      }
      window.requestAnimationFrame(loop);
    };

    window.requestAnimationFrame(loop);
    window.addEventListener('resize', () => {
      if (ready) {
        current = indexFromScroll();
        paint(current);
      }
    }, { passive: true });
  };

  initBlendPie();
  initBlendSpin();

  const CURRENCY_RATES = {
    USD: 1,
    CAD: 1.36,
    GBP: 0.78,
    EUR: 0.92,
    AUD: 1.52,
    MXN: 17.2
  };

  const moneyState = {
    code: 'USD',
    symbol: '$',
    country: 'US'
  };

  const formatMoney = (cents) => {
    const rate = CURRENCY_RATES[moneyState.code] || 1;
    const value = (Number(cents) || 0) / 100 * rate;
    return moneyState.symbol + value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const refreshMoney = () => {
    qsa('[data-money][data-cents]').forEach((node) => {
      node.textContent = formatMoney(node.getAttribute('data-cents'));
    });
  };

  const isLocalPreview = location.protocol.startsWith('file') || location.hostname === 'localhost';

  const setCurrencyOpen = (root, open) => {
    const toggle = qs('[data-currency-toggle]', root);
    const list = qs('[data-currency-list]', root);
    if (!toggle || !list) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
  };

  const paintCurrencyButton = (root, option) => {
    if (!root || !option) return;
    const flag = qs('[data-currency-flag]', root);
    const label = qs('[data-currency-label]', root);
    const toggle = qs('[data-currency-toggle]', root);
    const input = qs('[data-currency-input]', root);
    const code = option.getAttribute('data-currency') || '';
    const symbol = option.getAttribute('data-symbol') || '';
    const name = option.getAttribute('data-name') || '';
    const country = option.getAttribute('data-country') || '';
    if (flag) flag.src = option.getAttribute('data-flag') || flag.src;
    if (label) label.textContent = (code + ' ' + symbol).trim();
    if (toggle) toggle.setAttribute('aria-label', (name + ' ' + code + ' ' + symbol).trim());
    if (input) input.value = country;
    qsa('[data-currency-option]', root).forEach((btn) => {
      btn.classList.toggle('is-selected', btn === option);
    });
  };

  const applyCurrency = (option) => {
    if (!option) return;
    moneyState.code = option.getAttribute('data-currency') || 'USD';
    moneyState.symbol = option.getAttribute('data-symbol') || '$';
    moneyState.country = option.getAttribute('data-country') || 'US';
    document.body.setAttribute('data-currency', moneyState.code);
    document.body.setAttribute('data-currency-symbol', moneyState.symbol);
    try {
      localStorage.setItem('vktry-currency', moneyState.code);
      localStorage.setItem('vktry-country', moneyState.country);
    } catch (err) { /* ignore */ }
    qsa('[data-currency-switcher]').forEach((root) => {
      const match = qsa('[data-currency-option]', root).find((btn) => (
        btn.getAttribute('data-country') === moneyState.country
      )) || option;
      paintCurrencyButton(root, match);
      setCurrencyOpen(root, false);
    });
    if (typeof syncPdpPurchase === 'function') syncPdpPurchase();
    refreshMoney();
  };

  const goToShopTop = () => {
    const shopUrl = (document.body.getAttribute('data-shop-url') || '').trim();
    const onShop = document.body.classList.contains('template-product') || location.pathname.indexOf('/products/') === 0;
    if (onShop) {
      window.scrollTo(0, 0);
      return;
    }
    if (!shopUrl) return;
    const dest = new URL(shopUrl, location.origin);
    window.location.assign(dest.pathname + dest.search + dest.hash);
  };

  qsa('.vk-currency__form').forEach((form) => {
    form.addEventListener('submit', (event) => event.preventDefault());
  });

  qsa('[data-currency-switcher]').forEach((root) => {
    const toggle = qs('[data-currency-toggle]', root);
    const list = qs('[data-currency-list]', root);
    if (!toggle || !list) return;

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      setCurrencyOpen(root, toggle.getAttribute('aria-expanded') !== 'true');
    });

    qsa('[data-currency-option]', root).forEach((option) => {
      option.addEventListener('click', () => {
        const country = option.getAttribute('data-country') || '';
        const sameCountry = moneyState.country === country;
        applyCurrency(option);
        if (!sameCountry) goToShopTop();
      });
    });
  });

  const storedCountry = (() => {
    try { return localStorage.getItem('vktry-country') || ''; } catch (err) { return ''; }
  })();
  const storedCode = (() => {
    try { return localStorage.getItem('vktry-currency') || ''; } catch (err) { return ''; }
  })();
  const storedOption = qsa('[data-currency-option]').find((btn) => (
    storedCountry && btn.getAttribute('data-country') === storedCountry
  )) || qsa('[data-currency-option]').find((btn) => (
    storedCode && btn.getAttribute('data-currency') === storedCode
  ));
  if (storedOption) applyCurrency(storedOption);

  document.addEventListener('click', (event) => {
    qsa('[data-currency-switcher]').forEach((root) => {
      if (!root.contains(event.target)) setCurrencyOpen(root, false);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      qsa('[data-currency-switcher]').forEach((root) => setCurrencyOpen(root, false));
    }
  });
  refreshMoney();
  afterPdpSync = () => refreshMoney();
  syncPdpPurchase();

  const syncFlavorReviews = (flavorName) => {
    const pdp = qs('.pdp');
    const countEl = qs('[data-reviews-count]');
    if (!pdp || !countEl || !flavorName) return;
    const btn = qsa('[data-flavor]', pdp).find((n) => n.getAttribute('data-flavor-name') === flavorName);
    let count = btn && btn.getAttribute('data-review-count');
    if (!count) {
      try {
        const map = JSON.parse(pdp.getAttribute('data-flavor-reviews') || '{}');
        count = map[flavorName];
      } catch (err) {
        count = null;
      }
    }
    if (count) countEl.textContent = Number(count).toLocaleString() + ' Reviews';
  };

  qsa('[data-flavor][data-flavor-name], [data-pdp-thumb]').forEach((node) => {
    node.addEventListener('click', () => {
      syncFlavorReviews(node.getAttribute('data-flavor-name'));
    });
  });
  if (pdpRoot) syncFlavorReviews(pdpRoot.getAttribute('data-selected-flavor'));

  const updateTracker = () => {
    const tracker = qs('[data-discount-tracker]');
    if (!tracker) return;
    const unit = Number(tracker.getAttribute('data-unit-cents') || 2699);
    const ship = Number(tracker.getAttribute('data-ship-cents') || 5900);
    const qty = typeof readPdpQty === 'function' ? readPdpQty() : Number((qs('[data-pdp-quantity]') || {}).value || 1);
    const freqEl = qs('[data-pdp-freq] input:checked');
    const planSelect = qs('[data-pdp-plan-select]');
    const planOn = Boolean(
      freqEl &&
      freqEl.value === 'subscribe' &&
      ((planSelect && planSelect.value) || freqEl.getAttribute('data-selling-plan-id'))
    );
    const total = Math.round(unit * qty * pdpVolumeRate(qty) * (planOn ? 0.85 : 1));
    const fill = Math.min(100, Math.max(12, (total / Math.max(ship, unit * 5)) * 100));
    const bar = qs('[data-tracker-fill]', tracker);
    if (bar) bar.style.width = fill + '%';
    const remain = qs('[data-tracker-remain]', tracker);
    if (remain) {
      remain.textContent = total >= ship
        ? 'Free shipping unlocked'
        : formatMoney(ship - total) + ' to free shipping';
    }
    qsa('[data-tracker-step]', tracker).forEach((step) => {
      const key = step.getAttribute('data-tracker-step');
      const on = key === 'sub' ? planOn : Number(key) <= qty;
      step.classList.toggle('is-on', on);
    });
  };
  updateTracker();

  const doseX = (hour) => ((hour - 6) / 12) * 100;
  const DOSE_MODES = {
    athlete: {
      total: 'Total daily benefit (300 calories · 69g protein · 3 shots)',
      slots: [doseX(8), doseX(12), doseX(16)],
      marks: [
        { text: 'First thing\nevery morning' },
        { text: '30 min before\ntraining' },
        { text: 'Within 30 min\nafter training' }
      ]
    },
    cut: {
      total: 'Total daily benefit (200 calories · 46g protein · 2 shots)',
      slots: [doseX(8), null, doseX(15)],
      marks: [
        { text: 'Morning protein,\nno shake' },
        null,
        { text: 'Afternoon,\ninstead of a snack' }
      ]
    },
    gain: {
      total: 'Total daily benefit (300 calories · 69g protein · 3 shots)',
      slots: [doseX(7), doseX(11), doseX(17)],
      marks: [
        { text: 'Extra protein\nat breakfast' },
        { text: '30 min before\nlifting' },
        { text: 'Right after\nthe session' }
      ]
    },
    busy: {
      total: 'Total daily benefit (200 calories · 46g protein · 2 shots)',
      slots: [doseX(9), null, doseX(14)],
      marks: [
        { text: 'On the way\nout the door' },
        null,
        { text: 'When you cannot\nstop for a meal' }
      ]
    }
  };

  const paintDose = (mode, animate) => {
    const graph = qs('[data-dose-graph]');
    if (!graph) return;
    const data = DOSE_MODES[mode] || DOSE_MODES.athlete;
    const select = qs('[data-dose-select]', graph);
    if (select && select.value !== mode) select.value = mode;
    const hint = qs('[data-dose-hint]', graph);
    const option = select && select.selectedOptions[0];
    if (hint && option) hint.textContent = option.getAttribute('data-hint') || '';
    const total = qs('[data-dose-total]', graph);
    const marks = qsa('[data-dose-mark]', graph);
    const writeMark = (el, mark, x, index, lastVisible) => {
      el.classList.toggle('is-off', !mark);
      el.classList.toggle('is-start', Boolean(mark) && index === 0);
      el.classList.toggle('is-end', Boolean(mark) && index === lastVisible);
      const callout = qs('.vk-dose__callout', el);
      if (!mark) {
        if (callout) callout.textContent = '';
        return;
      }
      el.style.setProperty('--x', x + '%');
      if (callout) callout.innerHTML = mark.text.replace(/\n/g, '<br>');
    };
    if (animate && total) total.style.opacity = '0';
    marks.forEach((el, index) => {
      const callout = qs('.vk-dose__callout', el);
      if (animate && callout) callout.style.opacity = '0';
    });
    const apply = () => {
      const lastVisible = data.marks.reduce((last, mark, index) => (mark ? index : last), 0);
      marks.forEach((el, index) => writeMark(el, data.marks[index], data.slots[index], index, lastVisible));
      if (total) {
        total.textContent = data.total;
        total.style.opacity = '1';
      }
      marks.forEach((el) => {
        const callout = qs('.vk-dose__callout', el);
        if (callout) callout.style.opacity = el.classList.contains('is-off') ? '0' : '1';
      });
    };
    if (animate) {
      window.setTimeout(apply, 180);
    } else {
      apply();
    }
  };
  const doseSelect = qs('[data-dose-select]');
  if (doseSelect) {
    doseSelect.addEventListener('change', () => paintDose(doseSelect.value, true));
  }
  if (qs('[data-dose-graph]')) paintDose((doseSelect && doseSelect.value) || 'athlete', false);

  const paintHeaderCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  };

  const setCartOpen = (open) => {
    const drawer = qs('[data-cart-drawer]');
    const scrim = qs('[data-cart-scrim]');
    if (!drawer) return;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) {
      scrim.hidden = !open;
      scrim.classList.toggle('is-open', open);
    }
    document.documentElement.classList.toggle('vk-cart-open', open);
    if (open) {
      const popup = qs('[data-offer-popup]');
      if (popup) popup.setAttribute('data-open', 'false');
      const scroll = qs('[data-cart-scroll]', drawer);
      if (scroll) scroll.scrollTop = 0;
    }
  };

  const refreshOpenCart = async () => {
    const drawer = qs('[data-cart-drawer]');
    setCartOpen(true);
    if (drawer && typeof drawer.refreshCart === 'function') {
      const ok = await drawer.refreshCart();
      if (ok) return true;
    }
    return false;
  };

  const bindCartRoot = (cartRoot) => {
    if (!cartRoot || cartRoot.dataset.cartBound === 'true') return;
    cartRoot.dataset.cartBound = 'true';
    const shipCents = Number(cartRoot.getAttribute('data-ship-cents') || 5900);
    const showCartError = (message) => {
      const errorEl = qs('[data-cart-error]', cartRoot);
      if (!errorEl) return;
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    };
    const paintShip = (totalCents, itemCount) => {
      const remain = Math.max(0, shipCents - totalCents);
      const fill = Math.min(100, Math.max(0, (totalCents / Math.max(shipCents, 1)) * 100));
      const fillEl = qs('[data-ship-fill]', cartRoot);
      const remainEl = qs('[data-ship-remain]', cartRoot);
      if (fillEl) fillEl.style.width = fill + '%';
      if (remainEl) {
        if (itemCount < 1) remainEl.textContent = 'Free shipping over ' + formatMoney(shipCents);
        else if (remain <= 0) remainEl.textContent = 'Free shipping unlocked';
        else remainEl.textContent = formatMoney(remain) + ' to free shipping';
      }
    };
    const paintQtyLabel = (row, quantity) => {
      const qtyLabel = qs('[data-line-qty-label]', row);
      if (!qtyLabel) return;
      const pack = Number(qtyLabel.getAttribute('data-pack-size') || 6);
      const bottles = Math.max(0, Number(quantity) || 0) * (pack > 0 ? pack : 6);
      qtyLabel.textContent = (quantity === 1 ? '1 Box' : quantity + ' Boxes') + ' (' + bottles + ' Bottles)';
    };
    const paintLine = (item) => {
      const safeKey = (window.CSS && CSS.escape) ? CSS.escape(item.key) : item.key;
      const row = qs('[data-line-key="' + safeKey + '"]', cartRoot);
      if (!row) return false;
      const input = qs('[data-qty-input]', row);
      const minus = qs('[data-qty-minus]', row);
      const plus = qs('[data-qty-plus]', row);
      const max = Number(row.getAttribute('data-max-qty') || 99);
      if (input) input.value = item.quantity;
      if (minus) minus.disabled = item.quantity <= 1;
      if (plus) plus.disabled = item.quantity >= max;
      paintQtyLabel(row, item.quantity);
      const unit = qs('[data-line-unit]', row);
      if (unit && item.final_price != null) unit.setAttribute('data-cents', String(item.final_price));
      const line = qs('[data-line-total]', row);
      if (line) line.setAttribute('data-cents', String(item.final_line_price));
      const compare = qs('[data-line-compare]', row);
      if (compare) {
        compare.setAttribute('data-cents', String(item.original_line_price));
        compare.hidden = item.original_line_price <= item.final_line_price;
      }
      return true;
    };
    const filterCartRecs = (cart) => {
      const recs = qs('[data-cart-recs]', cartRoot);
      if (!recs) return;
      const items = cart && cart.items ? cart.items : [];
      const inCart = new Set(items.map((item) => String(item.product_id)));
      let visible = 0;
      qsa('[data-cart-rec]', recs).forEach((rec) => {
        const available = rec.getAttribute('data-available') !== 'false';
        const hide = !available || inCart.has(String(rec.getAttribute('data-product-id') || ''));
        rec.hidden = hide;
        if (!hide) visible += 1;
      });
      recs.hidden = visible < 1;
      const title = qs('[data-recs-title]', recs);
      if (title) {
        const emptyTitle = recs.getAttribute('data-title-empty') || 'Shop flavors';
        const filledTitle = recs.getAttribute('data-title-filled') || 'You might also like';
        title.textContent = items.length ? filledTitle : emptyTitle;
      }
    };
    const setEmptyState = (isEmpty) => {
      const empty = qs('[data-cart-empty]', cartRoot);
      const list = qs('[data-cart-list]', cartRoot);
      const foot = qs('[data-cart-foot]', cartRoot);
      const shop = qs('[data-cart-empty-shop]', cartRoot);
      if (empty) empty.hidden = !isEmpty;
      if (list) list.hidden = isEmpty;
      if (foot) foot.hidden = isEmpty;
      if (shop) shop.hidden = !isEmpty;
      if (isEmpty) filterCartRecs({ items: [], item_count: 0 });
    };
    const paintCart = (cart) => {
      const count = cart && cart.item_count ? cart.item_count : 0;
      if (count < 1) {
        qsa('[data-line-key]', cartRoot).forEach((row) => row.remove());
        setEmptyState(true);
        paintHeaderCount(0);
        paintShip(0, 0);
        const itemsLabel = qs('[data-cart-items-label]', cartRoot);
        if (itemsLabel) itemsLabel.textContent = '— 0 items';
        cartRoot.setAttribute('data-item-count', '0');
        refreshMoney();
        return;
      }
      setEmptyState(false);
      filterCartRecs(cart);
      const seen = {};
      (cart.items || []).forEach((item) => {
        seen[item.key] = true;
        paintLine(item);
      });
      qsa('[data-line-key]', cartRoot).forEach((row) => {
        if (!seen[row.getAttribute('data-line-key')]) row.remove();
      });
      const sub = qs('[data-cart-subtotal]', cartRoot);
      const total = qs('[data-cart-total]', cartRoot);
      const discount = qs('[data-cart-discount]', cartRoot);
      const discountRow = qs('[data-cart-discount-row]', cartRoot);
      const itemsLabel = qs('[data-cart-items-label]', cartRoot);
      if (sub) sub.setAttribute('data-cents', String(cart.items_subtotal_price));
      if (total) total.setAttribute('data-cents', String(cart.total_price));
      if (discount) discount.setAttribute('data-cents', String(cart.total_discount || 0));
      if (discountRow) discountRow.hidden = !(cart.total_discount > 0);
      if (itemsLabel) {
        itemsLabel.textContent = count === 1 ? '— 1 item' : '— ' + count + ' items';
      }
      cartRoot.setAttribute('data-item-count', String(count));
      paintHeaderCount(count);
      paintShip(cart.total_price, count);
      refreshMoney();
      showCartError('');
    };
    const refreshFromSection = async () => {
      const sectionId = cartRoot.getAttribute('data-section-id');
      if (!sectionId || isLocalPreview) return false;
      const wasOpen = cartRoot.getAttribute('data-open') === 'true';
      const res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + '?sections=' + encodeURIComponent(sectionId));
      const json = await res.json();
      const html = json[sectionId];
      if (!html) return false;
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const next = wrap.querySelector('[data-cart-drawer]') || wrap.querySelector('[data-cart]');
      const nextScrim = wrap.querySelector('[data-cart-scrim]');
      if (!next) return false;
      const scrim = qs('[data-cart-scrim]');
      cartRoot.replaceWith(next);
      if (scrim && nextScrim) scrim.replaceWith(nextScrim);
      bindCartRoot(next);
      if (wasOpen) setCartOpen(true);
      const count = Number(next.getAttribute('data-item-count') || 0);
      paintHeaderCount(count);
      refreshMoney();
      return true;
    };
    const changeQty = async (row, qty) => {
      const key = row.getAttribute('data-line-key');
      const max = Number(row.getAttribute('data-max-qty') || 99);
      const next = Math.max(0, Math.min(max, Number(qty) || 0));
      const liveInput = qs('[data-qty-input]', row);
      if (liveInput) liveInput.value = next;
      paintQtyLabel(row, next);
      if (isLocalPreview) {
        if (next < 1) row.remove();
        else {
          const unit = Number(row.getAttribute('data-unit-cents') || 0);
          paintLine({
            key,
            quantity: next,
            final_price: unit,
            final_line_price: unit * next,
            original_line_price: unit * next
          });
        }
        let subtotal = 0;
        let count = 0;
        const items = qsa('[data-line-key]', cartRoot).map((line) => {
          const input = qs('[data-qty-input]', line);
          const unit = Number(line.getAttribute('data-unit-cents') || 0);
          const q = Number((input && input.value) || 0);
          subtotal += unit * q;
          count += q;
          return {
            key: line.getAttribute('data-line-key'),
            quantity: q,
            final_price: unit,
            final_line_price: unit * q,
            original_line_price: unit * q
          };
        });
        paintCart({
          item_count: count,
          items,
          items_subtotal_price: subtotal,
          total_price: subtotal,
          total_discount: 0
        });
        return;
      }
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: next })
        });
        const data = await res.json();
        if (!res.ok) {
          showCartError(data.description || data.message || 'Could not update cart.');
          const fresh = await fetch('/cart.js').then((r) => r.json());
          if (!(await refreshFromSection())) paintCart(fresh);
          return;
        }
        if (!(await refreshFromSection())) paintCart(data);
      } catch (err) {
        showCartError('Could not update cart. Try again.');
      }
    };
    const addVariant = async (id, quantity, btn) => {
      if (isLocalPreview) {
        setCartOpen(true);
        return;
      }
      const label = (btn && (btn.getAttribute('data-label') || btn.textContent)) || 'Add';
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding…';
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: Number(quantity) || 1 })
        });
        const data = await res.json();
        if (!res.ok) {
          showCartError(data.description || data.message || 'Could not add to cart.');
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = label;
          }
          return;
        }
        setCartOpen(true);
        const drawer = qs('[data-cart-drawer]');
        if (drawer && drawer !== cartRoot && typeof drawer.refreshCart === 'function') {
          await drawer.refreshCart();
        } else if (!(await refreshFromSection())) {
          const fresh = await fetch('/cart.js').then((r) => r.json());
          paintCart(fresh);
        }
      } catch (err) {
        showCartError('Could not add to cart. Try again.');
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
        }
      }
    };

    qsa('[data-line-key]', cartRoot).forEach((row) => {
      const input = qs('[data-qty-input]', row);
      const minus = qs('[data-qty-minus]', row);
      const plus = qs('[data-qty-plus]', row);
      const remove = qs('[data-qty-remove]', row);
      if (minus) minus.addEventListener('click', () => changeQty(row, Number((input && input.value) || 1) - 1));
      if (plus) plus.addEventListener('click', () => changeQty(row, Number((input && input.value) || 1) + 1));
      if (input) {
        input.addEventListener('input', () => paintQtyLabel(row, Math.max(0, Number(input.value) || 0)));
        input.addEventListener('change', () => changeQty(row, input.value));
      }
      if (remove) {
        remove.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey) return;
          event.preventDefault();
          changeQty(row, 0);
        });
      }
    });
    qsa('[data-cart-add]', cartRoot).forEach((btn) => {
      btn.addEventListener('click', () => addVariant(btn.getAttribute('data-variant-id'), 1, btn));
    });
    const openingTotal = qs('[data-cart-total]', cartRoot);
    paintShip(Number((openingTotal && openingTotal.getAttribute('data-cents')) || 0), Number(cartRoot.getAttribute('data-item-count') || 0));
    cartRoot.addVariant = addVariant;
    cartRoot.refreshCart = refreshFromSection;
  };

  qsa('[data-cart]').forEach(bindCartRoot);

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-cart-open]');
    if (openBtn && qs('[data-cart-drawer]')) {
      event.preventDefault();
      setCartOpen(true);
      return;
    }
    const shopLink = event.target.closest('a[data-cart-close]');
    if (shopLink) {
      setCartOpen(false);
      return;
    }
    if (event.target.closest('[data-cart-close], [data-cart-scrim]')) {
      event.preventDefault();
      setCartOpen(false);
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setCartOpen(false);
  });

  const pdpForm = qs('.pdp__form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', async (event) => {
      const submitBtn = qs('.pdp__submit', pdpForm);
      if (submitBtn && submitBtn.disabled) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      if (isLocalPreview) {
        setCartOpen(true);
        return;
      }
      if (typeof syncPdpPurchase === 'function') syncPdpPurchase();
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.textContent = 'Adding…';
      }
      const formData = new FormData(pdpForm);
      formData.delete('return_to');
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        if (!(await refreshOpenCart())) {
          sessionStorage.setItem('vk-open-cart', '1');
          window.location.reload();
          return;
        }
      } catch (err) {
        sessionStorage.setItem('vk-open-cart', '1');
        pdpForm.submit();
        return;
      }
      if (submitBtn) {
        submitBtn.removeAttribute('aria-busy');
        syncPdpBuyCta();
      }
    });
  }
  if (!isLocalPreview && sessionStorage.getItem('vk-open-cart') === '1') {
    sessionStorage.removeItem('vk-open-cart');
    setCartOpen(true);
  }

  const gncStores = [
    { name: 'GNC — Times Square', city: 'New York, NY 10036', miles: '0.4 mi', stock: 'In stock' },
    { name: 'GNC — Flatiron', city: 'New York, NY 10010', miles: '1.1 mi', stock: 'In stock' },
    { name: 'GNC — Brooklyn Heights', city: 'Brooklyn, NY 11201', miles: '3.2 mi', stock: 'Limited' },
    { name: 'GNC — Hoboken', city: 'Hoboken, NJ 07030', miles: '4.8 mi', stock: 'In stock' }
  ];
  const renderGnc = (query) => {
    const list = qs('[data-gnc-list]');
    if (!list) return;
    const q = (query || '').trim().toLowerCase();
    const rows = gncStores.filter((store) => !q || store.city.toLowerCase().includes(q) || store.name.toLowerCase().includes(q));
    list.innerHTML = (rows.length ? rows : gncStores).map((store) => (
      `<li class="vk-locator__card"><strong>${store.name}</strong><p>${store.city} · ${store.miles}</p><span class="vk-locator__stock">${store.stock}</span></li>`
    )).join('');
  };
  const gncForm = qs('[data-gnc-form]');
  if (gncForm) {
    renderGnc('');
    gncForm.addEventListener('submit', (e) => {
      e.preventDefault();
      renderGnc((qs('[data-gnc-query]') || {}).value);
    });
  }

  const igEscape = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const igImageFromPost = (post) => {
    if (!post || typeof post !== 'object') return '';
    const sizes = post.sizes || {};
    const mediaType = post.mediaType || post.media_type || '';
    const children = Array.isArray(post.children) ? post.children : [];
    const child = children[0] || {};
    const childSizes = child.sizes || {};
    return (
      (sizes.medium && sizes.medium.mediaUrl) ||
      (sizes.large && sizes.large.mediaUrl) ||
      (sizes.small && sizes.small.mediaUrl) ||
      post.thumbnailUrl ||
      post.thumbnail_url ||
      (childSizes.medium && childSizes.medium.mediaUrl) ||
      child.thumbnailUrl ||
      (mediaType === 'VIDEO' ? '' : post.mediaUrl || post.media_url) ||
      child.mediaUrl ||
      post.mediaUrl ||
      post.media_url ||
      ''
    );
  };

  const normalizeIgPosts = (payload) => {
    const rows = Array.isArray(payload)
      ? payload
      : payload && Array.isArray(payload.posts)
        ? payload.posts
        : payload && Array.isArray(payload.data)
          ? payload.data
          : [];
    return rows.map((post) => {
      const image = igImageFromPost(post);
      if (!image) return null;
      const mediaType = String(post.mediaType || post.media_type || '').toUpperCase();
      const isReel = post.isReel === true || mediaType === 'VIDEO' || mediaType === 'REEL';
      const permalink = post.permalink || post.link || '';
      const alt = String(post.altText || post.prunedCaption || post.caption || 'VKTRY Protein on Instagram')
        .replace(/\s+/g, ' ')
        .trim();
      return { image, permalink, alt, isReel };
    }).filter(Boolean);
  };

  const igEmptyEl = (grid) => {
    const wrap = grid.closest('.vk-social__wrap') || grid.parentElement;
    return wrap ? wrap.querySelector('[data-instagram-empty]') : null;
  };

  const showIgEmpty = (grid, show) => {
    const empty = igEmptyEl(grid);
    grid.hidden = show;
    if (empty) empty.hidden = !show;
  };

  const paintIgGrid = (grid, posts) => {
    const handle = (grid.getAttribute('data-instagram-handle') || 'vktryprotein').replace(/^@/, '');
    const limit = Number(grid.getAttribute('data-instagram-limit') || 5);
    const slice = posts.slice(0, limit);
    const profile = `https://www.instagram.com/${handle}/`;
    if (!slice.length) {
      delete grid.dataset.igSig;
      grid.innerHTML = '';
      showIgEmpty(grid, true);
      return;
    }
    const sig = slice.map((post) => post.image).join('|');
    if (grid.dataset.igSig === sig) return;
    grid.dataset.igSig = sig;
    grid.style.setProperty('--ig-count', String(Number.isFinite(limit) && limit > 0 ? limit : 5));
    grid.innerHTML = slice.map((post) => {
      const href = post.permalink || profile;
      const reel = post.isReel ? '<span class="vk-social__reel" aria-hidden="true"></span>' : '';
      return `<a class="vk-social__cell" href="${igEscape(href)}" target="_blank" rel="noopener noreferrer">${reel}<img src="${igEscape(post.image)}" alt="${igEscape(post.alt)}" width="480" height="640" loading="lazy"></a>`;
    }).join('');
    showIgEmpty(grid, false);
  };

  const fetchIgPosts = async (source) => {
    const res = await fetch(source, { credentials: 'omit', cache: 'no-store' });
    if (!res.ok) throw new Error(`ig-feed ${res.status}`);
    return normalizeIgPosts(await res.json());
  };

  const loadIgGrid = async (grid) => {
    if (!grid || grid.dataset.igLoading === '1') return;
    const feedUrl = (grid.getAttribute('data-instagram-feed') || '').trim();
    const token = (grid.getAttribute('data-instagram-token') || '').trim();
    const limit = Number(grid.getAttribute('data-instagram-limit') || 5);
    const source = feedUrl || (token
      ? `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&limit=${limit}&access_token=${encodeURIComponent(token)}`
      : '');
    if (!source) return;
    grid.dataset.igLoading = '1';
    try {
      let posts = [];
      try {
        posts = await fetchIgPosts(source);
      } catch (err) {
        await new Promise((resolve) => setTimeout(resolve, 1200));
        posts = await fetchIgPosts(source);
      }
      paintIgGrid(grid, posts);
    } catch (err) {
      /* keep any server-rendered Instagram tiles */
    } finally {
      delete grid.dataset.igLoading;
    }
  };

  const igTimers = new WeakMap();
  const bindIgGrid = (grid) => {
    if (!grid || igTimers.has(grid)) return;
    loadIgGrid(grid);
    const tick = () => {
      if (!document.body.contains(grid)) {
        const id = igTimers.get(grid);
        if (id) clearInterval(id);
        igTimers.delete(grid);
        return;
      }
      if (document.visibilityState === 'hidden') return;
      loadIgGrid(grid);
    };
    igTimers.set(grid, setInterval(tick, 60 * 1000));
  };

  qsa('[data-instagram-grid]').forEach(bindIgGrid);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    qsa('[data-instagram-grid]').forEach(loadIgGrid);
  });
  document.addEventListener('shopify:section:load', (event) => {
    qsa('[data-instagram-grid]', event.target).forEach(bindIgGrid);
  });
})();
